import { Clickable, Col, Icon } from 'components';
import { theme } from 'lib';
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const ModalBg = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  background-color: ${(props) => props.bg || 'rgba(0, 0, 0, 0.8)'};
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.1s linear;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: inherit;
  position: relative;
`;

const ContentArea1 = styled.div`
  z-index: 1;
  width: 700px;
  max-height: 80vh;
  background-color: #fff;
  position: relative;
  overflow-y: scroll;
  scrollbar-width: none;

  @media (max-width: 1024px) {
    width: 100%;
    max-height: 80vh;
  }

  animation: ${fadeIn} 0.4s linear;
`;

const ContentArea2 = styled.div`
  z-index: 1;
  width: ${(props) => props.wid || '456px'};
  background-color: #fff;
  position: relative;
  overflow-y: scroll;
  scrollbar-width: none;
  border-radius: 24px;
  max-height: ${(props) => props.contentArea2MaxHt || '100%'};

  @media (max-width: 1024px) {
    width: 100%;
    max-height: 80vh;
    border-radius: 12px;
  }

  animation: ${fadeIn} 0.4s linear;
`;

const CloseContainer1 = styled.div`
  position: sticky;
  margin-right: 35.26px;
  top: 35.26px;
  height: 0;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 1024px) {
    margin-right: 24.92px;
    top: 24.92px;
  }
`;

const CloseContainer2 = styled.div`
  position: absolute;
  height: 64px;
  display: flex;
  justify-content: flex-end;
  right: 0;
  top: 0;

  @media (max-width: 1024px) {
    /* margin-right: 24.92px;
    top: 24.92px; */
  }
`;

const Modal = ({
  children,
  visible,
  closeModal,
  selfContent,
  website,
  wid,
  noOutsideClick,
  waiting = false,
  modalBg,
  closeIconFill = theme.GREY_60,
  style,
  ...props
}) => {
  const { isMobile } = useSelector((state) => state.appState);

  useEffect(() => {
    document.addEventListener('keydown', handleEsc);

    return () => document.removeEventListener('keydown', handleEsc);
  });

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
      return;
    }

    document.body.style.overflow = 'unset';
  }, [visible]);

  function handleEsc(e) {
    if (!visible || e.keyCode !== 27) return;

    closeModal();
  }

  function handleBgClose(e) {
    if (noOutsideClick) return null;

    // GUARD FOR SVG CLICKS
    if (typeof e.target.className === 'object') return;
    if (!e.target.className.includes('modal-container') && e.target.id !== 'modal') return null;

    closeModal();
  }

  if (!visible) return null;

  return createPortal(
    <ModalBg id="modal" className="modal-bg" onClick={handleBgClose} bg={modalBg} style={style}>
      <Container className="modal-container">
        {selfContent && <React.Fragment>{children}</React.Fragment>}

        {!website && !selfContent && (
          <ContentArea2 wid={wid} contentArea2MaxHt={props?.contentArea2MaxHt}>
            {!waiting && (
              <CloseContainer2>
                <Clickable onClick={closeModal} ogOpacity={waiting ? '0' : '1'} disabled={waiting}>
                  <Icon type="close" dimensions={14} col={closeIconFill} pad="21px" />
                </Clickable>
              </CloseContainer2>
            )}
            <Col>{children}</Col>
          </ContentArea2>
        )}

        {!selfContent && website && (
          <ContentArea1>
            {!waiting && (
              <CloseContainer1>
                <Clickable onClick={closeModal}>
                  <Icon type="close" dimensions={isMobile ? 22.17 : 34.42} />
                </Clickable>
              </CloseContainer1>
            )}
            <React.Fragment>{children}</React.Fragment>
          </ContentArea1>
        )}
      </Container>
    </ModalBg>,
    document.body
  );
};

export default Modal;
